import type { FC, SelectHTMLAttributes } from 'react'
import { Icon } from './Icon.js'
import { useFieldContext } from './Field.js'

export interface SelectOption {
  value: string
  label: string
}

type NativeProps = Omit<
  SelectHTMLAttributes<HTMLSelectElement>,
  'value' | 'onChange' | 'className'
>

export interface SelectProps extends NativeProps {
  value: string
  onChange: (value: string) => void
  options: ReadonlyArray<SelectOption>
  placeholder?: string
  invalid?: boolean
}

export const Select: FC<SelectProps> = ({
  value,
  onChange,
  options,
  placeholder,
  invalid,
  id,
  ...rest
}) => {
  const field = useFieldContext()
  const bad = invalid ?? field?.invalid ?? false

  return (
    <span className="control-wrap">
      <select
        {...rest}
        id={id ?? field?.id}
        className={`control select${bad ? ' control--invalid' : ''}`}
        value={value}
        aria-invalid={bad || undefined}
        aria-describedby={field?.describedBy}
        aria-required={field?.required || undefined}
        onChange={(e) => onChange(e.currentTarget.value)}
      >
        {placeholder !== undefined ? (
          <option value="">{placeholder}</option>
        ) : null}
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <span className="select__caret">
        <Icon name="down" size={18} />
      </span>
    </span>
  )
}
